import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';

import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const ChangeManyDate = () => {
    let access = localStorage.getItem("accesstoken");
    const location = useLocation();
    const idList = location.search.split('=')[1];
        useEffect(() => {
            const getdata =async () => {
                const response = await axiosInstance.get(`${databaseUrl}/orderboard/findmany?id=${idList}`);
                const dataList = [];
                for(let i = 0; i < response.data.length; i++){
                    const newInputdate = response.data[i].inputdate.substring(0,10);
                    const obj = {
                        id : response.data[i].id,
                        inputdate : newInputdate,
                        company : response.data[i].order_company,
                        material : response.data[i].material,
                        weight : response.data[i].material_weight,
                        due_date : response.data[i].due_date,
                        isdeposit : response.data[i].deposit,
                        depositPrice : response.data[i].deposit_price,
                        depositDay : response.data[i].deposit_day,
                        depositSend : response.data[i].deposit_send,
                        delivery : response.data[i].delivery,
                        deliverydate : response.data[i].delivery_date,
                        note : response.data[i].note
                    }
                    dataList.push(obj);
                }
                setDataList([...dataList])
                setDeliverydate(response.data[0].delivery_date);
            }
            getdata();
    }, [])
    const [notaccess, setNotaccess] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [deliverydate,setDeliverydate] = useState('');


    const changeDeliveryDate = (_changeDate) => {
        setDeliverydate(_changeDate);
    }
    const sendChangedDate = () => {
        axios.get(`${databaseUrl}/orderboard/changemanydate?id=${idList}&chdate=${deliverydate}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            window.open('','_self').close(); 
        })
    }
    return (
        <div>
        <div><h1>{notaccess}</h1></div>
        <table className='table_normal'>
            <thead>
                 <tr><th colSpan="13">배송일 일괄 변경</th></tr>
            <tr>
                <th>번호</th>
                <th>접수일</th>
                <th>발주처</th>
                <th>품명</th>
                <th>수량</th>
                <th>요청납기일</th>
                <th>선입금</th>
                <th>선입금액</th>
                <th>입금일</th>
                <th>입금금액</th>
                <th>배송</th>
                <th>배송일</th>
                <th>비고</th>
            </tr>
            </thead>
            <tbody>
                {dataList.map((data,i)=>
                <tr key={i}>
                    <td>{data.id}</td>
                    <td>{data.inputdate}</td>
                    <td>{data.company}</td>
                    <td>{data.material}</td>
                    <td>{data.weight}</td>
                    <td>{data.due_date}</td>
                    <td>{data.isdeposit}</td>
                    <td>{data.depositPrice}</td>
                    <td>{data.depositDay}</td>
                    <td>{data.depositSend}</td>
                    <td>{data.delivery}</td>
                    {i === 0 ?
                        <td rowSpan={dataList.length} className='mustinput'><input type='date' value={deliverydate} onChange={(event)=>changeDeliveryDate(event.target.value)}></input></td> : ''
                    }                    
                    <td>{data.note}</td>
                </tr>                
                )}
            <tr><td colSpan='13'>
                <Button onClick={sendChangedDate} size='large' variant="contained" color="success"  sx={{width:'100%'}}>Submit</Button>
            </td>
            </tr>
            </tbody>
        </table>
        </div>
    )
}
export default ChangeManyDate;
